// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__KT0nw","title":"Home_title__24lYP"};